import { DeceasedReligion, religionLabels } from './deceasedReligion';

//* 부고장 헤더 종교·예우 테마 — 디자이너 어셋(src/assets/obituaryTheme) 기준
//* - 별도 저장 필드 없음: 고인 종교 선택값(religion, 국가유공자 포함)에서 그때그때 판정
//* - 어셋이 테마당 1벌이라 종교 Select 택1이 곧 테마(국가유공자도 같은 선택지 — 별도 체크와 조합 금지)
//* - 무교(일반, none)도 디자이너 default 프레임(3차 어셋, 상징 없음)을 쓴다. 미설정(undefined)만 옛 기본 헤더
export const obituaryThemes = [
  'buddhist',
  'christian',
  'catholic',
  'nationalMerit',
  'default',
] as const;
export type ObituaryTheme = typeof obituaryThemes[number];

//* 종교 라벨은 deceasedReligion 한 벌에서 가져오고 default만 테마 고유 라벨
export const obituaryThemeLabels: Record<ObituaryTheme, string> = {
  buddhist: religionLabels.buddhist,
  christian: religionLabels.christian,
  catholic: religionLabels.catholic,
  nationalMerit: religionLabels.nationalMerit,
  default: '일반',
};

export interface ObituaryThemeSource {
  religion?: DeceasedReligion;
}

/** 무교(none)=default 프레임. 미설정(undefined)·알 수 없는 값만 undefined → 옛 기본 헤더 */
export const resolveObituaryTheme = (
  info: ObituaryThemeSource | undefined,
): ObituaryTheme | undefined => {
  const religion = info?.religion;
  if (religion === 'none') return 'default';
  //* 'default'는 테마 키일 뿐 종교 값이 아니라 제외(먼저 걸러야 TS 좁히기가 맞음)
  return obituaryThemes.find((theme) => theme !== 'default' && theme === religion);
};
